import { EditUserModalForm } from "./EditUserModalForm"


const EditUserModalFormWrapper = () => {
    return (<EditUserModalForm />)
}

export {EditUserModalFormWrapper}